import React from 'react';
import './TemplateCard.css';

/**
 * Template Card Component
 * Reusable card for displaying template information with actions
 * 
 * Used in both TemplateBrowser and PinnedTemplates components
 */
const TemplateCard = ({
    template,
    onPin,
    onUnpin,
    onExecute,
    isPinned = false,
    maxPinsReached = false,
    showDragHandle = false,
    dragHandleProps = {}
}) => {

    const handleExecute = (e) => {
        // Prevent if clicking on action buttons
        if (e && e.target.closest('.template-actions')) {
            return;
        }
        console.log('[TemplateCard] ⚙️ Execute clicked:', template.id);
        onExecute(template);
    };

    const handlePin = (e) => {
        e.stopPropagation(); // Prevent card click
        console.log('[TemplateCard] 📌 Pin clicked:', template.id);
        onPin(template.id);
    };

    const handleUnpin = (e) => {
        e.stopPropagation(); // Prevent card click
        console.log('[TemplateCard] 🗑️ Unpin clicked:', template.id);
        onUnpin(template.id);
    };

    return (
        <div className="template-card" onClick={handleExecute} style={{ cursor: 'pointer' }}>
            {showDragHandle && (
                <span
                    className="drag-handle"
                    title="Drag to reorder"
                    {...dragHandleProps}
                >
                    ⋮⋮
                </span>
            )}

            <div className="template-info">
                <h4 className="template-name">{template.name}</h4>

                <p className="template-meta">
                    <span className="template-id">ID: {template.id}</span>
                    <span className="template-type-badge">{template.template_type}</span>
                </p>

                {template.description && (
                    <p className="template-description">{template.description}</p>
                )}
            </div>

            <div className="template-actions" onClick={(e) => e.stopPropagation()}>
                {onPin && (
                    <button
                        className={`action-btn pin-btn ${isPinned ? 'pinned' : ''}`}
                        onClick={handlePin}
                        disabled={isPinned || maxPinsReached}
                        title={
                            isPinned
                                ? 'Already pinned'
                                : maxPinsReached
                                    ? 'Maximum favourites reached'
                                    : 'Pin to Favourites'
                        }
                    >
                        {isPinned ? '✓' : '📌'}
                    </button>
                )}

                {onUnpin && (
                    <button
                        className="action-btn unpin-btn"
                        onClick={handleUnpin}
                        title="Remove from Favourites"
                    >
                        🗑️
                    </button>
                )}

                <button
                    className="action-btn execute-btn"
                    onClick={handleExecute}
                    title="Execute with default parameters"
                >
                    ⚙️
                </button>
            </div>
        </div>
    );
};

export default TemplateCard;
